import { createTranslationFile, createLanguage } from "@vocab/core/runtime";
const translations = createTranslationFile({
  en: createLanguage({
    "Sign in": "Sign in",
    "Sign up": "Sign up",
    "Sign out": "Sign out",
    Settings: "Settings"
  }),
  th: createLanguage({
    "Sign in": "เข้าสู่ระบบ",
    "Sign up": "ลงทะเบียน",
    "Sign out": "ออกจากระบบ",
    Settings: "การตั้งค่า"
  }),
  id: createLanguage({
    "Sign in": "Masuk",
    "Sign up": "Mendaftar",
    "Sign out": "Keluar",
    Settings: "Pengaturan"
  }),
  zh: createLanguage({
    "Sign in": "登入",
    "Sign up": "註冊",
    "Sign out": "登出",
    Settings: "設定"
  }),
  "en-AU": createLanguage({
    "Sign in": "Sign in",
    "Sign up": "Sign up",
    "Sign out": "Sign out",
    Settings: "Settings"
  }),
  "en-HK": createLanguage({
    "Sign in": "Sign in",
    "Sign up": "Sign up",
    "Sign out": "Sign out",
    Settings: "Settings"
  }),
  "en-ID": createLanguage({
    "Sign in": "Sign in",
    "Sign up": "Sign up",
    "Sign out": "Sign out",
    Settings: "Settings"
  }),
  "en-MY": createLanguage({
    "Sign in": "Sign in",
    "Sign up": "Sign up",
    "Sign out": "Sign out",
    Settings: "Settings"
  }),
  "en-NZ": createLanguage({
    "Sign in": "Sign in",
    "Sign up": "Sign up",
    "Sign out": "Sign out",
    Settings: "Settings"
  }),
  "en-PH": createLanguage({
    "Sign in": "Sign in",
    "Sign up": "Sign up",
    "Sign out": "Sign out",
    Settings: "Settings"
  }),
  "en-SG": createLanguage({
    "Sign in": "Sign in",
    "Sign up": "Sign up",
    "Sign out": "Sign out",
    Settings: "Settings"
  }),
  "en-TH": createLanguage({
    "Sign in": "Sign in",
    "Sign up": "Sign up",
    "Sign out": "Sign out",
    Settings: "Settings"
  }),
  "th-TH": createLanguage({
    "Sign in": "เข้าสู่ระบบ",
    "Sign up": "ลงทะเบียน",
    "Sign out": "ออกจากระบบ",
    Settings: "การตั้งค่า"
  }),
  "id-ID": createLanguage({
    "Sign in": "Masuk",
    "Sign up": "Mendaftar",
    "Sign out": "Keluar",
    Settings: "Pengaturan"
  }),
  "zh-HK": createLanguage({
    "Sign in": "登入",
    "Sign up": "註冊",
    "Sign out": "登出",
    Settings: "設定"
  }),
  "en-PSEUDO": createLanguage({
    "Sign in": "[Šìììģกี้ ìììกี้]",
    "Sign up": "[Šìììģกี้ ǚǚǚƥ]",
    "Sign out": "[Šìììģกี้ öööǚǚǚṯ]",
    Settings: "[Šẽẽẽṯṯìììกี้ģš]"
  })
});
export {
  translations
};
